import { AppEnvironmentAPIConfig } from './environment.api.config.model';

export class AppEnvironmentConfig {
  APIs: AppEnvironmentAPIConfig;
  public _populate(data: Partial<AppEnvironmentConfig>): void {
    Object.assign(this, data);
  }
}
